[
  [
    "K",
    "Kick"
  ],
  [
    "8",
    "808"
  ],
  [
    "S",
    "Snare"
  ],
  [
    "C",
    "Clap"
  ],
  [
    "R",
    "Rim"
  ],
  [
    "H",
    "Hat"
  ],
  [
    "O",
    "Open hat"
  ],
  [
    "P",
    "Shaker"
  ],
  [
    "B",
    "Cowbell"
  ]
]
